module.exports = __webpack_public_path__ + "img/RAD-logo.c385e398.png";